import React, { useEffect, useState } from "react";
import * as R from "ramda";
import $ from "jquery";
import { Link, NavLink } from "react-router-dom";

import Emptylustration from "./../../assets/images/svg/057-contract-1.svg";
import anticipa from "./../../assets/images/svg/112-person-white.svg";
import facilita from "./../../assets/images/svg/113-funeral.svg";
import serenita from "./../../assets/images/svg/145-customer-service.svg";

import { ModalCalendy } from "./modalCalendy";

export const Dashboard = ({ users, partner, etablissement, isPartner, partnerstate, anticipaUsersRepresentative, facilitaUsersRepresentative, serenitaUsersRepresentative }) => {
	const filterOptions = { all: "tous", notAccepted: "n'a pas accepté", ongoing: "en cours", finished: "complété", yearAndMore: "plus d'un an", closed: "clôture" };
	const facilitafilterOptions = { all: "tous", notAccepted: "n'a pas accepté", ongoing: "en cours", sending: "A envoyer" };
	// const facilitafilterOptions = { all: "tous", notAccepted: "n'a pas accepté", ongoing: "en cours", sending: "A envoyer", overtime: "Dépassé la limite" };
	const [filterAnticipa, setFilterAnticipa] = useState(filterOptions.all);
	const [filterFacilita, setFilterFacilita] = useState(facilitafilterOptions.all);
	const [filterSerenita, setFilterSerenita] = useState(facilitafilterOptions.all);

	const [headerStatistics, setHeaderStatistics] = useState({ facilita: partnerstate.allDossiers.totalFacilita, anticipa: partnerstate.allDossiers.totalAnticipa, serenita: partnerstate.allDossiers.totalSerenita });
	const [anticipaUsers, setAnticipaUsers] = useState([]);
	const [facilitaUsers, setFacilitaUsers] = useState([]);
	const [serenitaUsers, setSerenitaUsers] = useState([]);

	useEffect(() => {
		if (R.isNil(anticipaUsersRepresentative) && R.isNil(facilitaUsersRepresentative) && R.isNil(serenitaUsersRepresentative)) return;

		if (filterAnticipa === filterOptions.all) {
			setAnticipaUsers(anticipaUsersRepresentative);
		} else {
			setAnticipaUsers(anticipaUsersRepresentative.filter((u) => filterOptions[u.status] === filterAnticipa));
		}

		if (filterFacilita === facilitafilterOptions.all) {
			setFacilitaUsers(facilitaUsersRepresentative);
		} else {
			setFacilitaUsers(facilitaUsersRepresentative.filter((u) => facilitafilterOptions[u.status] === filterFacilita));
		}

		if (filterSerenita === facilitafilterOptions.all) {
			setSerenitaUsers(serenitaUsersRepresentative);
		} else {
			setSerenitaUsers(serenitaUsersRepresentative.filter((u) => facilitafilterOptions[u.status] === filterSerenita));
		}
	}, [filterAnticipa, filterFacilita, filterSerenita, anticipaUsersRepresentative, facilitaUsersRepresentative, serenitaUsersRepresentative]);

	if (window.location.search !== "") {
		const modal = new URLSearchParams(window.location.search).get("showModal");
		if (modal === "calendly") {
			$("#commencerReferent").modal("show");
		}
	}
	return (
		<article className="view-calc pt-6 mb-auto">
			<div className="container-fluid">
				<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-4">
					<div className="grid grid-sm-narrow grid-xl-4">
						<Link to="/partner/anticipa" className="card rounded shadow">
							<div className="card-body media p-2">
								<div className="rounded-max bg-gradient-primary text-white d-inherit mr-3 h-6 w-6 rounded-max text-center">
									<img className="img-fluid m-auto my-3 mb-2 py-1 text-white" src={anticipa + "#person-white"} alt="Anticipa" />
								</div>
								<div className="media-body my-auto text-truncate">
									<h1 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">nombre dossier</h1>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{headerStatistics.anticipa} Anticipa</p>
								</div>
							</div>
						</Link>
						<Link to="/partner/facilita" className="card rounded shadow">
							<div className="card-body media p-2">
								<div className="rounded-max bg-dim d-inherit mr-3 h-6 w-6 rounded-max text-center">
									<img className="img-fluid m-auto my-3 mb-2 py-1" src={facilita} alt="Facilita" />
								</div>
								<div className="media-body my-auto text-truncate">
									<h1 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">nombre dossier</h1>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{headerStatistics.facilita} Facilita</p>
								</div>
							</div>
						</Link>
						{!R.isNil(etablissement) && etablissement.isSerenita ? (
							<Link to="/partner/facilita" className="card rounded shadow">
								<div className="card-body media p-2">
									<div className="rounded-max bg-dim d-inherit mr-3 h-6 w-6 rounded-max text-center">
										<img className="img-fluid m-auto my-3 mb-2 py-1" src={serenita} alt="Serenita" />
									</div>
									<div className="media-body my-auto text-truncate">
										<h1 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">nombre dossier</h1>
										<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{headerStatistics.serenita} Serenita</p>
									</div>
								</div>
							</Link>
						) : (
							""
						)}
						{/* <div className="card rounded shadow">
							<div className="card-body media p-2">
								<div className="rounded-max bg-dim d-inherit mr-3 h-6 w-6 rounded-max text-center">
									<img className="img-fluid m-auto my-3 mb-2 py-1" src={archives} alt="archives" />
								</div>
								<div className="media-body my-auto text-truncate">
									<h1 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Alerte</h1>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">0 utilisateurs</p>
								</div>
							</div>
						</div> */}
						{!isPartner ? (
							<Link className="card rounded shadow" role="button" to="/partner/create-dossier">
								<div className="card-body p-2 media btn-alert my-auto">
									<div className="rounded-max btn-alert-info d-inherit mr-3 h-6 w-6 rounded-max text-center">
										<i className="eva eva-folder-add-outline m-auto h1 lh-1"></i>
									</div>
									<div className="media-body my-auto text-truncate text-info">
										<h1 className="h5 text-uppercase font-weight-bolder my-auto text-truncate">
											ajouter un <br />
											nouveau dossier
										</h1>
									</div>
								</div>
							</Link>
						) : (
							""
						)}
						{/* <Link className="card rounded shadow disabled" role="button" to="/partner/create-dossier" disabled={isPartner}>
								<div className="card-body p-2 media btn-alert my-auto">
									<div className="rounded-max btn-alert-info d-inherit mr-3 h-6 w-6 rounded-max text-center">
										<i className="eva eva-folder-add-outline m-auto h1 lh-1" ></i>
									</div>
									<div className="media-body my-auto text-truncate text-info">
										<h1 className="h5 text-uppercase font-weight-bolder my-auto text-truncate">ajouter un <br />nouveau dossier</h1>
									</div>
								</div>
							</Link> */}
					</div>
				</header>
			</div>
			<div className="auto-view h-100 mb-auto">
				<div className="container-fluid">
					<section className="block mb-4">
						<div className="grid grid-2 align-items-center mt-2">
							<div className="media">
								<div className="btn btn-icon bg-faded p-2 rounded-max my-auto mr-3 disabled">
									<i className="btn-icon eva eva-folder-outline fs-4"></i>
								</div>
								<h2 className="h1 lh-copy font-weight-black my-auto media-body">Anticipa</h2>
							</div>
							<div className="my-auto ml-auto">
								<Link to="/partner/anticipa" className="btn p-1 align-middle text-info stretched-link">
									Voir tout <i className="eva eva-arrow-right-outline align-middle fs-lead"></i>
								</Link>
							</div>
						</div>
						<nav className="navbar navbar-expand-lg navbar-light px-0 mb-2">
							<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mb-2 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
								<span className="btn-alert-secondary eva eva-funnel-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
								<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Appliquer filtre à la vue</span>
							</button>
							<div className="collapse navbar-collapse" id="navbarNav">
								<ul className="nav nav-fill nav-pills bg-lg-dim rounded-max">
									{Object.entries(filterOptions)
										.map((entry) => entry[1])
										.map((option, index) => {
											return (
												<button key={index} className={"nav-item text-uppercase rounded-inherit" + (filterAnticipa === option ? " bg-secondary text-white" : " bg-none")} onClick={() => setFilterAnticipa(option)}>
													<div className="nav-link py-1">
														{option} {option === "tous" && <span className="d-none d-xl-inline-block">les dossiers</span>}
													</div>
												</button>
											);
										})}

									{/* <NavLink exact to="/partner/dashboard" activeClassName="bg-secondary text-white" className="nav-item text-uppercase rounded-inherit">
											<div className="nav-link py-1">tous les dossiers</div>
										</NavLink>
										<Link to="#" className="nav-item text-uppercase rounded-inherit">
											<div className="nav-link py-1">n'a pas accepté</div>
										</Link>
										<Link to="#" className="nav-item text-uppercase rounded-inherit">
											<div className="nav-link py-1">en cours</div>
										</Link>
										<Link to="#" className="nav-item text-uppercase rounded-inherit">
											<div className="nav-link py-1">terminé</div>
										</Link>
										<Link to="#" className="nav-item text-uppercase rounded-inherit">
											<div className="nav-link py-1">plus d'un an</div>
										</Link> */}
								</ul>
							</div>
						</nav>
						{!R.isEmpty(anticipaUsers) ? (
							<div className="grid grid-sm-min grid-lg-narrow grid-xl-4 py-xs">
								{anticipaUsers.slice(0, 50).map((user) => {
									const userEtablissement = isPartner ? partnerstate.etablissementList.items.find((i) => i.id === user.etablissementId) : null;
									return (
										<div className="card text-center shadow h-100 rounded border-0" key={user.id}>
											{/* <div className="card-header alin-items-center px-2 py-1">
										<button className="btn btn-icon btn-stage-secondary rounded-max p-2 mx-1" data-toggle="modal" data-target="#DonnesProfile"><i className="eva fs-sm eva-person-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-secondary" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Données personnelles"></i></button>
										<button className="btn btn-icon btn-stage-warning rounded-max p-2 mx-1 shadow-none"><i className="eva fs-sm eva-email-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-white-warning" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2"></div></div>' title="Envoyer un e-mail de récupération"></i></button>
										<button className="btn btn-icon btn-stage-info rounded-max p-2 mx-1 shadow-none" data-toggle="modal" data-target="#paySummary"><i className="eva fs-sm eva-credit-card-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-white-info" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2"></div></div>' title="Voir Paiements"></i></button>
									</div>
									<hr className="my-0" /> */}
											<div className="card-body my-auto px-3">
												<h4 className="h3 text-capitalize ls-n1 font-weight-black mt-auto mb-2">
													{user.firstName + " " + user.lastName}
													{user.hasHrDocuments ? <span className="badge fs-1 bg-info text-white lj-1 px-2 py-1 align-middle ml-1">RH</span> : ""}
												</h4>
												<p className="fs-3 text-uppercase lh-copy o-40 font-weight-bolder mb-0">{!R.isNil(user.mainRepresentative) ? user.mainRepresentative.firstName + " " + user.mainRepresentative.lastName : ""}</p>
												<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
													{filterOptions[user.status] === filterOptions.notAccepted ? (
														<>
															<div className="progress-bar h-100 rounded-inherit" style={{ width: `0%` }} role="progressbar"></div>
															<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid" role="progressbar">
																N'a pas accepté
															</div>
														</>
													) : filterOptions[user.status] === filterOptions.ongoing ? (
														<>
															<div className="progress-bar h-100 rounded-inherit bg-secondary o-20" style={{ width: `50%` }} role="progressbar"></div>
															<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-secondary h6 my-auto text-uppercase lh-solid" role="progressbar">
																en cours
															</div>
														</>
													) : filterOptions[user.status] === filterOptions.finished ? (
														<>
															<div className="progress-bar h-100 rounded-inherit bg-primary o-20" style={{ width: `100%` }} role="progressbar"></div>
															<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-primary h6 my-auto text-uppercase lh-solid" role="progressbar">
																Complété
															</div>
														</>
													) : (
														<>
															<div className="progress-bar h-100 rounded-inherit o-20 bg-none" style={{ width: `100%` }} role="progressbar"></div>
															<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-primary h6 my-auto text-uppercase lh-solid" role="progressbar">
																Contrat d'un an
															</div>
														</>
													)}
												</div>
												<p className="fs-2 mt-2 lh-copy o-40 font-weight-bolder mb-0">{new Intl.DateTimeFormat("fr-FR").format(user.creationDate)}</p>
											</div>
											{isPartner ? (
												<div className="card-footer flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder py-1 bg-light rounded-top-0">
													<span className="o-60">Etablissement: </span>
													<span className="text-uppercase mx-1">{userEtablissement.name}</span>
												</div>
											) : (
												""
											)}
										</div>
									);
								})}
							</div>
						) : (
							<section className="block text-center m-auto py-xs">
								<img className="img-fluid img-contain container-paper mx-auto mt-auto mb-3" src={Emptylustration} width={70} alt="Assist@" />
								<div className="block text-center container-thin mx-auto mb-auto">
									<h1 className="h1 font-weight-semi ls-n2 lh-1">Aucun dossier</h1>
									<p className="fs-aux o-80 mb-0">S'il vous plaît voir un autre état.</p>
								</div>
							</section>
						)}
					</section>
					<section className="block mb-4">
						<div className="grid grid-2 align-items-center mt-2">
							<div className="media">
								<div className="btn btn-icon bg-faded p-2 rounded-max my-auto mr-3 disabled">
									<i className="btn-icon eva eva-folder-outline fs-4"></i>
								</div>
								<h2 className="h1 lh-copy font-weight-black my-auto media-body">Facilita</h2>
							</div>
							<div className="my-auto ml-auto">
								<Link to="/partner/facilita" className="btn p-1 align-middle text-info stretched-link">
									Voir tout <i className="eva eva-arrow-right-outline align-middle fs-lead"></i>
								</Link>
							</div>
						</div>
						<nav className="navbar navbar-expand-lg navbar-light px-0 mb-2">
							<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mb-2 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
								<span className="btn-alert-secondary eva eva-funnel-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
								<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Appliquer filtre à la vue</span>
							</button>
							<div className="collapse navbar-collapse" id="navbarNav">
								<ul className="nav nav-fill nav-pills bg-lg-dim rounded-max">
									{Object.entries(facilitafilterOptions)
										.map((entry) => entry[1])
										.map((option, index) => {
											return (
												<button key={index} className={"nav-item text-uppercase rounded-inherit" + (filterFacilita === option ? " bg-secondary text-white" : " bg-none")} onClick={() => setFilterFacilita(option)}>
													<div className="nav-link py-1">
														{option} {option === "tous" && <span className="d-none d-xl-inline-block">les dossiers</span>}
													</div>
												</button>
											);
										})}
								</ul>
							</div>
						</nav>

						{!R.isNil(facilitaUsers) && !R.isEmpty(facilitaUsers) ? (
							<div className="grid grid-sm-min grid-lg-narrow grid-xl-4 py-xs">
								{facilitaUsers.slice(0, 50).map((user) => {
									const userEtablissement = isPartner ? partnerstate.etablissementList.items.find((i) => i.id === user.etablissementId) : null;
									return (
										<div className="card text-center shadow h-100 rounded border-0" key={user.id}>
											{/* <div className="card-header alin-items-center px-2 py-1">
											<button className="btn btn-icon btn-stage-secondary rounded-max p-2 mx-1" data-toggle="modal" data-target="#DonnesProfile"><i className="eva fs-sm eva-person-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-secondary" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Données personnelles"></i></button>
											<button className="btn btn-icon btn-stage-warning rounded-max p-2 mx-1 shadow-none"><i className="eva fs-sm eva-email-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-white-warning" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2"></div></div>' title="Envoyer un e-mail de récupération"></i></button>
											<button className="btn btn-icon btn-stage-info rounded-max p-2 mx-1 shadow-none" data-toggle="modal" data-target="#paySummary"><i className="eva fs-sm eva-credit-card-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-white-info" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2"></div></div>' title="Voir Paiements"></i></button>
										</div>
										<hr className="my-0" /> */}
											<div className="card-body my-auto px-3">
												<h4 className="h3 text-capitalize ls-n1 font-weight-black mt-auto mb-2">
													{user.firstName + " " + user.lastName} {user.hasHrDocuments ? <span className="badge fs-1 bg-info text-white lj-1 px-2 py-1 align-middle ml-1">RH</span> : ""}
												</h4>
												<p className="fs-3 text-uppercase lh-copy o-40 font-weight-bolder mb-0">{!R.isNil(user.mainRepresentative) ? user.mainRepresentative.firstName + " " + user.mainRepresentative.lastName : ""}</p>
												<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
													{
														facilitafilterOptions[user.status] === facilitafilterOptions.notAccepted ? (
															<>
																<div className="progress-bar h-100 rounded-inherit" style={{ width: `0%` }} role="progressbar"></div>
																<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid" role="progressbar">
																	N'a pas accepté
																</div>
															</>
														) : facilitafilterOptions[user.status] === facilitafilterOptions.ongoing ? (
															<>
																<div className="progress-bar h-100 rounded-inherit bg-secondary o-20" style={{ width: `50%` }} role="progressbar"></div>
																<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-secondary h6 my-auto text-uppercase lh-solid" role="progressbar">
																	en cours
																</div>
															</>
														) : (
															<>
																<div className="progress-bar h-100 rounded-inherit bg-secondary o-20" style={{ width: `100%` }} role="progressbar"></div>
																<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-secondary h6 my-auto text-uppercase lh-solid" role="progressbar">
																	A envoyer
																</div>
															</>
														)

														// facilitafilterOptions[user.status] === facilitafilterOptions.sending ?
														// 	<>
														// 		<div className="progress-bar h-100 rounded-inherit bg-secondary o-20" style={{ width: `100%` }} role="progressbar"></div>
														// 		<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-secondary h6 my-auto text-uppercase lh-solid" role="progressbar">A envoyer</div>
														// 	</>
														// 	:
														// 	<>
														// 		<div className="progress-bar h-100 rounded-inherit o-20 bg-none" style={{ width: `100%` }} role="progressbar"></div>
														// 		<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-primary h6 my-auto text-uppercase lh-solid" role="progressbar">Dépassé la limite</div>
														// 	</>
													}
												</div>
												<p className="fs-2 mt-2 lh-copy o-40 font-weight-bolder mb-0">{new Intl.DateTimeFormat("fr-FR").format(user.creationDate)}</p>
											</div>
											{isPartner ? (
												<div className="card-footer flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder py-1 bg-light rounded-top-0">
													<span className="o-60">Etablissement: </span>
													<span className="text-uppercase mx-1">{userEtablissement.name}</span>
												</div>
											) : (
												""
											)}
										</div>
									);
								})}
							</div>
						) : (
							<section className="block text-center m-auto py-xs">
								<img className="img-fluid img-contain container-paper mx-auto mt-auto mb-3" src={Emptylustration} width={70} alt="Assist@" />
								<div className="block text-center container-thin mx-auto mb-auto">
									<h1 className="h1 font-weight-semi ls-n2 lh-1">Aucun dossier</h1>
									<p className="fs-aux o-80 mb-0">S'il vous plaît voir un autre état.</p>
								</div>
							</section>
						)}
					</section>

					{!R.isNil(etablissement) && etablissement.isSerenita ? (
						<section className="block mb-4">
							<div className="grid grid-2 align-items-center mt-2">
								<div className="media">
									<div className="btn btn-icon bg-faded p-2 rounded-max my-auto mr-3 disabled">
										<i className="btn-icon eva eva-folder-outline fs-4"></i>
									</div>
									<h2 className="h1 lh-copy font-weight-black my-auto media-body">Serenita</h2>
								</div>
								<div className="my-auto ml-auto">
									<Link to="/partner/serenita" className="btn p-1 align-middle text-info stretched-link">
										Voir tout <i className="eva eva-arrow-right-outline align-middle fs-lead"></i>
									</Link>
								</div>
							</div>
							<nav className="navbar navbar-expand-lg navbar-light px-0 mb-2">
								<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mb-2 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
									<span className="btn-alert-secondary eva eva-funnel-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
									<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Appliquer filtre à la vue</span>
								</button>
								<div className="collapse navbar-collapse" id="navbarNav">
									<ul className="nav nav-fill nav-pills bg-lg-dim rounded-max">
										{Object.entries(facilitafilterOptions)
											.map((entry) => entry[1])
											.map((option, index) => {
												return (
													<button key={index} className={"nav-item text-uppercase rounded-inherit" + (filterSerenita === option ? " bg-secondary text-white" : " bg-none")} onClick={() => setFilterSerenita(option)}>
														<div className="nav-link py-1">
															{option} {option === "tous" && <span className="d-none d-xl-inline-block">les dossiers</span>}
														</div>
													</button>
												);
											})}
									</ul>
								</div>
							</nav>
							{!R.isNil(serenitaUsers) && !R.isEmpty(serenitaUsers) ? (
								<div className="grid grid-sm-min grid-lg-narrow grid-xl-4 py-xs">
									{serenitaUsers.slice(0, 50).map((user) => {
										const userEtablissement = isPartner ? partnerstate.etablissementList.items.find((i) => i.id === user.etablissementId) : null;
										return (
											<div className="card text-center shadow h-100 rounded border-0" key={user.id}>
												{/* <div className="card-header alin-items-center px-2 py-1">
												<button className="btn btn-icon btn-stage-secondary rounded-max p-2 mx-1" data-toggle="modal" data-target="#DonnesProfile"><i className="eva fs-sm eva-person-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-secondary" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Données personnelles"></i></button>
												<button className="btn btn-icon btn-stage-warning rounded-max p-2 mx-1 shadow-none"><i className="eva fs-sm eva-email-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-white-warning" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2"></div></div>' title="Envoyer un e-mail de récupération"></i></button>
												<button className="btn btn-icon btn-stage-info rounded-max p-2 mx-1 shadow-none" data-toggle="modal" data-target="#paySummary"><i className="eva fs-sm eva-credit-card-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip tooltip-white-info" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2"></div></div>' title="Voir Paiements"></i></button>
											</div>
											<hr className="my-0" /> */}
												<div className="card-body my-auto px-3">
													<h4 className="h3 text-capitalize ls-n1 font-weight-black mt-auto mb-2">
														{user.firstName + " " + user.lastName} {user.hasHrDocuments ? <span className="badge fs-1 bg-info text-white lj-1 px-2 py-1 align-middle ml-1">RH</span> : ""}
													</h4>
													<p className="fs-3 text-uppercase lh-copy o-40 font-weight-bolder mb-0">{!R.isNil(user.mainRepresentative) ? user.mainRepresentative.firstName + " " + user.mainRepresentative.lastName : ""}</p>
													<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center mt-3 bg-dim"}>
														{
															facilitafilterOptions[user.status] === facilitafilterOptions.notAccepted ? (
																<>
																	<div className="progress-bar h-100 rounded-inherit" style={{ width: `0%` }} role="progressbar"></div>
																	<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid" role="progressbar">
																		N'a pas accepté
																	</div>
																</>
															) : facilitafilterOptions[user.status] === facilitafilterOptions.ongoing ? (
																<>
																	<div className="progress-bar h-100 rounded-inherit bg-secondary o-20" style={{ width: `50%` }} role="progressbar"></div>
																	<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-secondary h6 my-auto text-uppercase lh-solid" role="progressbar">
																		en cours
																	</div>
																</>
															) : (
																<>
																	<div className="progress-bar h-100 rounded-inherit bg-secondary o-20" style={{ width: `100%` }} role="progressbar"></div>
																	<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-secondary h6 my-auto text-uppercase lh-solid" role="progressbar">
																		A envoyer
																	</div>
																</>
															)

															// facilitafilterOptions[user.status] === facilitafilterOptions.sending ? (
															// 	<>
															// 		<div className="progress-bar h-100 rounded-inherit bg-secondary o-20" style={{ width: `100%` }} role="progressbar"></div>
															// 		<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-secondary h6 my-auto text-uppercase lh-solid" role="progressbar">
															// 			A envoyer
															// 		</div>
															// 	</>
															// ) : (
															// 	<>
															// 		<div className="progress-bar h-100 rounded-inherit o-20 bg-none" style={{ width: `100%` }} role="progressbar"></div>
															// 		<div className="d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder text-primary h6 my-auto text-uppercase lh-solid" role="progressbar">
															// 			Dépassé la limite
															// 		</div>
															// 	</>
															// )
														}
													</div>
													<p className="fs-2 mt-2 lh-copy o-40 font-weight-bolder mb-0">{new Intl.DateTimeFormat("fr-FR").format(user.creationDate)}</p>
												</div>
												{isPartner ? (
													<div className="card-footer flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder py-1 bg-light rounded-top-0">
														<span className="o-60">Etablissement: </span>
														<span className="text-uppercase mx-1">{userEtablissement.name}</span>
													</div>
												) : (
													""
												)}
											</div>
										);
									})}
								</div>
							) : (
								<section className="block text-center m-auto py-xs">
									<img className="img-fluid img-contain container-paper mx-auto mt-auto mb-3" src={Emptylustration} width={70} alt="Assist@" />
									<div className="block text-center container-thin mx-auto mb-auto">
										<h1 className="h1 font-weight-semi ls-n2 lh-1">Aucun dossier</h1>
										<p className="fs-aux o-80 mb-0">S'il vous plaît voir un autre état.</p>
									</div>
								</section>
							)}
						</section>
					) : (
						""
					)}

					{/* <hr></hr>
					<div className="card rounded shadow mb-4">
						<div className="card-body p-2">
							<div className="media-body my-auto text-truncate">
								<h1 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Lien de création de compte Aidavie</h1>
								<p className="fs-2">
									<a href={`https://victorious-sand-0919d3403.2.azurestaticapps.net/auth/signup?partnerId=${partner.id}&etablissementId=${partnerstate.etablissement.id || ""}`} target="_blank" rel="noopener noreferrer" className="text-info">
										{`https://victorious-sand-0919d3403.2.azurestaticapps.net/auth/signup?etablissementInfo=${partner.id}&etablissementId=${partnerstate.etablissement.id || ""}`}
									</a>
								</p>
							</div>
						</div>
					</div> */}
				</div>
			</div>
			<ModalCalendy />
		</article>
	);
};
